import { styled } from "@mui/material";

export const StyledUl = styled("ul")({
  paddingLeft: "32px", // Removes the default indentation
});
